import React from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faSpinner} from '@fortawesome/free-solid-svg-icons'
const Loadergift = ({displayVal})=> {
    return (
         <div className='spinnerContainer' style={displayVal === 'none' ? {display:'none'} : undefined} role='status' aria-label='Loading videos'>
             <FontAwesomeIcon icon={faSpinner} className='spinner' spin />
         </div>
    )
 }
 Loadergift.defaulfProps = {
    displayVal:'block'
 }
 export default Loadergift